import { useModal } from 'components/modal';
import React from 'react';
import { FinsightEntity } from 'shared';

import { CreateEntityModalMain } from './index.view';

export function useCreateEntityModal() {
  const { showModal } = useModal();

  return {
    showCreateEntityModal: (
      type: string,
      parent?: FinsightEntity,
      options?: {
        moreClicked?: boolean;
      },
    ) => {
      showModal(
        '',
        <CreateEntityModalMain
          type={type}
          parent={parent}
          moreClicked={options?.moreClicked}
        />,
        '',
        {
          sx: {
            flex: '0 1 1000px',
          },
        },
      );
    },
  };
}
